import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-add-popup',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="modal-overlay" (click)="onClose()">
      <div class="modal-card" (click)="$event.stopPropagation()">
        <div class="close-x" (click)="onClose()">           
        <img [src]="'assets/images/closeIcon.svg'" alt="Icon" class="form-icon">
        </div>
        <div class="c-body">
        <div class="modal-header-content">
          <div class="icon-container">
           <img [src]="iconPath" alt="Icon" class="form-icon">
          </div>
          <h3>{{ title }}</h3>
          <p>{{ subtitle }}</p>
        </div>

        <div class="modal-body">
          <ng-content></ng-content>
        </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./add-popup.component.css']
})
export class AddPopupComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() iconPath = 'assets/images/DesignationPopupIcon.svg';
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }
}